import React, { useEffect, useState } from "react";

import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@material-ui/core";

import TextFieldCustom from "../../components/basic/TextFieldCustom";
import Btn from "../../components/buttons/Btn";
import { notify } from "../../utils/notify";
import validatesNotNull from "../../utils/validatesNotNull";
import {
  createCancellation,
  editCancellation,
} from "../../repositories/cancellationRepository";

function UpdateCreateCancellation({ row, handleClose, handleSave }) {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [contactType, setContactType] = useState("comercial");
  const [statusType, setStatusType] = useState("C");

  useEffect(() => {
    setDescription(row?.Descricao || "");
    setContactType(row?.TipoContato || "comercial");
    setStatusType(row?.TipoStatus || "C");
  }, [row]);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const validation = validatesNotNull([
        { key: "description", value: description },
      ]);

      setErrors(validation.errorsValidation);
      if (validation.error) return;

      const body = {
        Descricao: description,
        TipoContato: contactType,
        TipoStatus: statusType,
      };

      let resp = {};
      if (row?.Id) {
        resp = await editCancellation({
          id: row.Id,
          body,
        });
      } else {
        resp = await createCancellation({
          body,
        });
      }

      resp = resp.data;

      if (!resp?.success) {
        return notify("Não foi possível salvar os dados.");
      }

      notify("Motivo salvo com sucesso.", true, "info");

      handleSave({ ...body, Id: row?.Id || resp?.data?.Id });

      handleClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={true}
      onClose={loading ? () => {} : handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Vinculo Contrato ERP</DialogTitle>
      <DialogContent>
        <Grid container alignItems="center" justify="space-around" spacing={2}>
          <Grid item xs={12}>
            <TextFieldCustom
              maxLength={255}
              label="Descrição"
              type="text"
              value={description}
              setValue={setDescription}
              error={errors.description}
              helperText={errors.description}
            />
          </Grid>

          <Grid item flex={1}>
            <FormControl>
              <FormLabel>Tipo de Contato</FormLabel>
              <RadioGroup
                aria-label="contact type"
                name="contactType"
                value={contactType}
                onChange={(e) => setContactType(e.target.value)}
              >
                <FormControlLabel
                  value="comercial"
                  control={<Radio color="primary" />}
                  label="Comercial"
                />
                <FormControlLabel
                  value="financeiro"
                  control={<Radio color="primary" />}
                  label="Financeiro"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item flex={1}>
            <FormControl>
              <FormLabel>Tipo de Status</FormLabel>
              <RadioGroup
                aria-label="status type"
                name="statusType"
                value={statusType}
                onChange={(e) => setStatusType(e.target.value)}
              >
                <FormControlLabel
                  value="C"
                  control={<Radio color="primary" />}
                  label="Cancelado"
                />
                <FormControlLabel
                  value="S"
                  control={<Radio color="primary" />}
                  label="Suspenso"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {!loading && (
          <Btn
            onClick={handleClose}
            label="Cancelar"
            bg-color="subGray"
            textcolor="gray"
          />
        )}

        <Btn
          onClick={handleSubmit}
          label={
            loading ? (
              <CircularProgress
                style={{ width: 22, height: 22, color: "white" }}
              />
            ) : (
              "Salvar"
            )
          }
        />
      </DialogActions>
    </Dialog>
  );
}

export { UpdateCreateCancellation };
